const MONTHS = {
  jan: 1, january: 1, feb: 2, february: 2, mar: 3, march: 3, apr: 4, april: 4, may: 5,
  jun: 6, june: 6, jul: 7, july: 7, aug: 8, august: 8, sep: 9, sept: 9, september: 9,
  oct: 10, october: 10, nov: 11, november: 11, dec: 12, december: 12,
};
const MON = "(january|february|march|april|may|june|july|august|september|sept|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|oct|nov|dec)(?![a-z])";
const SEP = "[\\s_.,/-]*";
const DAY = "(\\d{1,2})(?!\\d)(?:st|nd|rd|th)?";
const mon = (s) => MONTHS[s.toLowerCase()];

// Numeric a-b-YYYY is day-first; month-first only when day-first is impossible (b > 12).
const dayOrMonthFirst = (a, b, y) => (+b > 12 && +a <= 12 ? [y, a, b, "day_us"] : [y, b, a, "day"]);

// [regex, (match) => candidates [[year, month, day, precision], ...]] — first valid match wins.
const PATTERNS = [
  [/(?<!\d)(\d{4})[-_. ](\d{1,2})[-_. ](\d{1,2})(?!\d)/g, (m) => [[m[1], m[2], m[3], "day"]]],
  [/(?<!\d)(\d{1,2})[-_. /](\d{1,2})[-_. /](\d{4})(?!\d)/g, (m) => [dayOrMonthFirst(m[1], m[2], m[3])]],
  [/(?<!\d)(\d{8})(?!\d)/g, ([, d]) => [[d.slice(0, 4), d.slice(4, 6), d.slice(6), "day"],
    dayOrMonthFirst(d.slice(0, 2), d.slice(2, 4), d.slice(4))]],
  [new RegExp(`(?<!\\d)${DAY}${SEP}(?<![a-z])${MON}${SEP}(\\d{4})(?!\\d)`, "gi"),
    (m) => [[m[3], mon(m[2]), m[1], "day"]]],
  [new RegExp(`(?<![a-z])${MON}${SEP}${DAY}${SEP}(\\d{4})(?!\\d)`, "gi"),
    (m) => [[m[3], mon(m[1]), m[2], "day"]]],
  [new RegExp(`(?<![a-z])${MON}${SEP}(\\d{4})(?!\\d)`, "gi"), (m) => [[m[2], mon(m[1]), 1, "month"]]],
  [/(?<!\d)((?:19|20)\d{2})(?!\d)/g, (m) => [[m[1], 1, 1, "year"]]],
];

const pad = (n) => String(n).padStart(2, "0");
const localISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

function toValidISO(y, m, d, today) {
  const [Y, M, D] = [+y, +m, +d];
  if (Y < 1990 || M < 1 || M > 12 || D < 1) return null;
  const dt = new Date(Y, M - 1, D);
  if (dt.getMonth() !== M - 1 || dt.getDate() !== D) return null;
  const iso = localISO(dt);
  return iso <= today ? iso : null;
}

// Returns { date: "YYYY-MM-DD", precision: "day"|"day_us"|"month"|"year" } or null.
export function suggestDocumentDate(filename, now = new Date()) {
  let name = (filename || "").replace(/\.[a-z0-9]{1,5}$/i, "");
  const today = localISO(now);
  for (const [rx, pick] of PATTERNS) {
    for (const m of name.matchAll(rx)) {
      for (const [y, mo, d, precision] of pick(m)) {
        const date = toValidISO(y, mo, d, today);
        if (date) return { date, precision };
      }
    }
    // Blank out rejected matches so looser patterns don't reuse their parts.
    name = name.replace(rx, (s) => " ".repeat(s.length));
  }
  return null;
}
